export const highlightedToDropdownFiltersMapping: { [filterId: string]: { dropdownFilterId: string; options: string[] } } = {
	growth: {
		dropdownFilterId: 'riskProfile',
		options: ['moderate aggressive', 'aggressive']
	},
	capital_preservation: {
		dropdownFilterId: 'riskProfile',
		options: ['conservative']
	},
	esg: {
		dropdownFilterId: 'preferences',
		options: ['esg']
	},
	tax_aware: {
		dropdownFilterId: 'preferences',
		options: ['tax aware']
	},
	alternatives: {
		dropdownFilterId: 'preferences',
		options: ['alternatives']
	}
};
